<template>
  <Modal
    v-model:visible="isShowAdd"
    :title="titleMap[modalType]"
    :footer="null"
    class="new-style-modal"
    @cancel="closeModal"
    :maskClosable="false"
    :width="465"
  >
    <div class="ipts" v-if="modalType == 'phone'">
      <em>*</em>
      <span class="label">手机号码：</span>
      <a-input placeholder="请输入" v-model:value="info.tel" />
      <p class="tips" v-if="info.telTips">请输入正确的手机号码</p>
    </div>
    <div class="ipts" v-if="modalType == 'email'">
      <em>*</em>
      <span class="label">邮箱：</span>
      <a-input placeholder="请输入" v-model:value="info.email" />
      <p class="tips" v-if="info.emailTips">请输入正确的邮箱</p>
    </div>
    <div class="ipts" v-if="modalType == 'name'">
      <em>*</em>
      <span class="label">昵称：</span>
      <a-input placeholder="请输入" v-model:value="info.name" />
      <p class="tips" v-if="info.nameTips">请输入昵称</p>
    </div>
    <div class="footer">
      <a-button class="cancel-btn" @click="closeModal">取消</a-button>
      <a-button type="primary" @click="handleClick">确定</a-button>
    </div>
  </Modal>
</template>
<script lang="ts" setup>
import { ref, watch, reactive, nextTick } from 'vue'
import { message, Modal } from 'ant-design-vue'
import 'ant-design-vue/lib/modal/style/css'
import { accountApi } from '@/api/account'

const titleMap = {
  phone: '修改手机号码',
  email: '修改邮箱',
  name: '修改昵称'
}

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  modalType: {
    type: String,
    default: 'phone'
  },
  editData: {
    type: Object,
    default: null
  }
})
const emit = defineEmits(['refreshList', 'update:modelValue'])

const isShowAdd = ref(props.modelValue)
watch(
  () => props.modelValue,
  () => {
    isShowAdd.value = props.modelValue
    if (props.modelValue) {
      info.tel = props.editData.tel
      info.email = props.editData.email
      info.name = props.editData.name
    }
  }
)
const info = reactive({
  tel: '',
  telTips: false,
  email: '',
  emailTips: false,
  name: '',
  nameTips: false
})
const resetInfo = () => {
  info.tel = ''
  info.email = ''
  info.name = ''
  nextTick(() => {
    info.telTips = false
    info.emailTips = false
    info.nameTips = false
  })
}
const closeModal = () => {
  emit('update:modelValue', false)
  resetInfo()
}
const checkTel = () => {
  return /^(1[0-9]{1})+\d{9}$/.test(info.tel)
}
const checkEmail = () => {
  if (/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(info.email)) {
    return true
  } else {
    return false
  }
}
const checkName = () => {
  return info.name.length > 0
}
watch(
  () => info.tel,
  () => {
    info.telTips = !checkTel()
  },
  {
    deep: true
  }
)
watch(
  () => info.email,
  () => {
    info.emailTips = !checkEmail()
  },
  {
    deep: true
  }
)
watch(
  () => info.name,
  () => {
    info.nameTips = !checkName()
  },
  {
    deep: true
  }
)
const handleClick = () => {
  let errorTips = false
  switch (props.modalType) {
    case 'phone':
      errorTips = !checkTel()
      break
    case 'email':
      errorTips = !checkEmail()
      break
    case 'name':
      errorTips = !checkName()
  }
  if (errorTips) {
    return
  }
  editData()
}

const editData = async () => {
  try {
    await accountApi.updateCustomerUser({
      id: props.editData.id,
      mobile: info.tel,
      email: info.email,
      name: info.name
    })
  } catch (e) {
    console.warn('editData error', e)
    message.error(e?.data?.message || '提交失败，请重试！')
    return
  }
  message.success('编辑成功')
  closeModal()
  emit('refreshList', 'edit')
}
</script>
<style lang="less" scoped>
.ipts {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  position: relative;
  em {
    display: inline-block;
    width: 13px;
    font-size: 16px;
    line-height: 20px;
    color: rgba(227, 77, 89, 1);
  }
  .label {
    font-size: 14px;
    text-align: right;
    color: rgba(0, 0, 0, 0.9);
    word-break: keep-all;
  }
  :deep(.ant-input) {
    width: 360px;
  }
  .tips {
    position: absolute;
    left: 87px;
    bottom: -44px;
    color: red;
  }
}
:deep(.ant-input) {
  width: 248px;
  border-color: #f7f8fa;
  background: #f7f8fa;
  &:hover,
  &:focus {
    // border-color: var(--text-btn-color);
  }
}
.footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  .cancel-btn {
    margin-right: 8px;
  }
}
:deep(.ant-modal-close-x) {
  line-height: 70px;
}
.cancel-btn:hover {
  border-color: @primary-color;
  color: @primary-color;
}
:deep(.ant-btn-primary) {
  border-color: @primary-color;
  background: @primary-color;
}
</style>
